// extracted by mini-css-extract-plugin
module.exports = {"container":"RecBlock_container__3UF1J","recommmendationLinkTop":"RecBlock_recommmendationLinkTop__onbMb","recommmendationLinkBottom":"RecBlock_recommmendationLinkBottom__6qBtw"};